import React from 'react';
import { alpha, Box, styled } from '@mui/material';
import Grid from '@mui/material/Unstable_Grid2';

export const GeneralTile = ({ title, to, promote, children, ...rest }) => {
  return (
    <TileContainer xs={2} {...rest}>
      <TileBody promote={promote}>
        <CardContent className='HomeCardContent'>
          <div className='definition'>{children}</div>
        </CardContent>
      </TileBody>
    </TileContainer>
  );
};

const TileContainer = styled(Grid)(() => ({
  position: 'relative',
  display: 'flex',
}));

TileContainer.defaultProps = {
  item: true,
  zeroMinWidth: true,
};

const TileBody = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'inverse' && prop !== 'promote',
})(({ theme, inverse, promote }) => ({
  position: 'relative',
  display: 'flex',
  flexDirection: 'column',
  flex: 1,

  backgroundColor: inverse ? alpha(theme.palette.primary.light, 0.05) : theme.palette.common.white,
  border: `1px solid ${theme.palette.grey[200]}`,
  borderRadius: '0.5rem',
  boxShadow: theme.shadows[4],
  padding: theme.spacing(4),
  paddingBottom: theme.spacing(6),
  textAlign: 'left',
  transition: 'box-shadow .3s ease-in-out, background-color .2s',

  '&:before': {
    content: '""',
    position: 'absolute',
    bottom: 0,
    right: 0,
    display: 'block',
    borderRadius: `0 0 0.5rem 0`,
    width: 30,
    height: 60,
    transition: 'width .2s',

    backgroundImage: `linear-gradient(to bottom right, transparent 50%, ${
      promote ? theme.palette.warning.main : 'rgba(0, 113, 188, 0.25)'
    } 51%)`,
    backgroundRepeat: `no-repeat`,
    backgroundSize: '100%',
  },
  '&:after': {
    content: `""`,
    position: 'absolute',
    bottom: 2,
    right: 2,

    display: 'block',
    backgroundRepeat: 'no-repeat',
    height: 24,
    width: 24,
  },

  '.title': {
    position: 'relative',
    color: theme.palette.primary.main,
    paddingBottom: theme.spacing(1),
    zIndex: 1,

    a: {
      color: 'inherit',
      textDecoration: 'none',
    },
  },
}));

const CardContent = styled(Box)(({ theme }) => ({
  marginTop: -12,
  '.title': {
    fontSize: '2rem',
    fontWeight: 900,

    '&:after': {
      content: `""`,
      position: 'absolute',
      bottom: 0,
      right: 0,
      left: 0,

      display: 'block',
      backgroundColor: theme.palette.grey[300],
      height: 2,
    },
  },
  '.definition': {
    fontSize: '24px',
    lineHeight: 1.2,
    marginTop: theme.spacing(1),
    zIndex: 1,
    display: 'flex',
    flexGrow: 1,
  },
  '.promote': {
    flexShrink: 0,
    color: theme.palette.secondary.light,
    fontSize: '.875rem',
    fontWeight: 'bold',
    lineHeight: 1,
    height: 12,
    textTransform: 'uppercase',
  },
  '.new': {
    color: theme.palette.error.main,
    fontSize: '.875rem',
    fontWeight: 'bold',
    lineHeight: 1,
    height: 12,
    textTransform: 'uppercase',
    float: 'right',
  },
  '.HomeCardContent': {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
  },
}));
